import { render } from "./query.vue?vue&type=template&id=4e452ff6&scoped=true"
import script from "./query.vue?vue&type=script&lang=js"
export * from "./query.vue?vue&type=script&lang=js"

import "./query.vue?vue&type=style&index=0&id=4e452ff6&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e452ff6"]])

export default __exports__